// commonUtils.ts

import type { LocalizedOrPlainString, MultipleChoiceQuestion } from "@/types/Questions.types";
import type { WrongQuestionData } from "@/types/Quiz.types";

const joinLocalizedString = (input: LocalizedOrPlainString | undefined): string => {
  if (input === undefined) {
    return "";
  }
  if (typeof input === "string") {
    return input; // Plain string – nothing to join
  }
  // Assume both 'en' and 'zh-hk' exist (or fallback as needed)
  return `${input.en}\n${input["zh-hk"]}`;
};

export function getOptionText(q: MultipleChoiceQuestion, optionKey: string) {
  const options = q.option as unknown as Record<string, unknown>;
  const option = options[optionKey];
  return joinLocalizedString(option as LocalizedOrPlainString);
}

export function groupAndChunkQuestions(data: WrongQuestionData[], chunkSize = 10) {
  // 1. Group by Quiz ID
  const grouped = data.reduce(
    (acc, curr) => {
      const key = curr.quiz.id;
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    },
    {} as Record<string, WrongQuestionData[]>,
  );

  // 2. Chunk into sets of 10
  return Object.entries(grouped).map(([quizId, questions]) => {
    const chunks: WrongQuestionData[][] = [];
    for (let i = 0; i < questions.length; i += chunkSize) {
      chunks.push(questions.slice(i, i + chunkSize));
    }
    return {
      quizId,
      quizMeta: questions[0].quiz,
      chunks,
    };
  });
}

export { joinLocalizedString };
